import { render } from "./WheelSwipeNotice.vue?vue&type=template&id=2293dc86&scoped=true"
import script from "./WheelSwipeNotice.vue?vue&type=script&lang=ts"
export * from "./WheelSwipeNotice.vue?vue&type=script&lang=ts"

import "./WheelSwipeNotice.vue?vue&type=style&index=0&id=2293dc86&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2293dc86"

export default script